import type { Point } from "../types";

/** The `<g data-shape-id>` wrapper rendered by `ShapeNode`. */
export const findShapeNode = (
  svg: SVGSVGElement,
  id: string
): SVGGElement | null =>
  svg.querySelector<SVGGElement>(`[data-shape-id="${CSS.escape(id)}"]`);

/** Scratch translation written straight to the DOM during a drag. */
export const setTranslate = (nodes: SVGGElement[], delta: Point): void => {
  const value = `translate(${delta.x} ${delta.y})`;
  for (const node of nodes) node.setAttribute("transform", value);
};

export const setScratchTransform = (
  nodes: SVGGElement[],
  transform: string
): void => {
  for (const node of nodes) node.setAttribute("transform", transform);
};

export const clearScratchTransform = (nodes: SVGGElement[]): void => {
  for (const node of nodes) node.removeAttribute("transform");
};
